export function AvatarIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#clip0_13326_4966)'>
        <rect width='32' height='32' rx='16' fill='#F3F4F6' />
        <path
          d='M32 27.9933V32.0026H0V28.008C1.86127 25.5206 4.27721 23.5018 7.05572 22.112C9.83423 20.7223 12.8987 20 16.0053 20.0026C22.544 20.0026 28.352 23.1413 32 27.9933ZM21.336 12.0013C21.336 13.4158 20.7741 14.7723 19.7739 15.7725C18.7737 16.7727 17.4172 17.3346 16.0027 17.3346C14.5882 17.3346 13.2316 16.7727 12.2314 15.7725C11.2312 14.7723 10.6693 13.4158 10.6693 12.0013C10.6693 10.5868 11.2312 9.23026 12.2314 8.23007C13.2316 7.22987 14.5882 6.66797 16.0027 6.66797C17.4172 6.66797 18.7737 7.22987 19.7739 8.23007C20.7741 9.23026 21.336 10.5868 21.336 12.0013Z'
          fill='#D1D5DB'
        />
      </g>
      <defs>
        <clipPath id='clip0_13326_4966'>
          <rect width='32' height='32' rx='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
